/* src/app/pages/project/map/repository/import-wizard/components/geospatial/step2-mapping_adjusts/import-wizard-geospatial-mapping_adjust.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  min-height: 0;
}
.tabular-mapping-container {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 1rem;
  flex: 1;
  min-height: 0;
}
.columns-mapping-container {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  grid-column: span 5;
  border: 1px solid #333;
  border-radius: 12px;
  flex: 1;
  padding: 0.5rem 1rem;
  overflow-x: hidden;
  overflow-y: hidden;
}
.preview-tabular-container {
  display: flex;
  flex-direction: column;
  grid-column: span 3;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.feature-item {
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
}
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.table-wrapper {
  border: 1px solid rgb(51, 51, 51);
  border-radius: 10px;
  overflow: auto;
  flex: 1;
}
.search-input-dimension {
  margin-bottom: 12px;
  width: 100%;
}
.alias-input-dimension {
  margin-bottom: 0px;
  max-width: 450px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}
.button-container > button {
  background: #FACC15;
  color: #2a2a2a;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: #FACC15;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
.button-container > button:active {
  transform: translateY(0);
}
.button-container > button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.button-container > button.secondary {
  background: #444444;
  color: #ffffff;
}
.button-container > button.secondary:hover {
  background: #3d3d3d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.pending-list-progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-color: var(--primary);
}
.pending-list-progress-bar {
  --mdc-linear-progress-active-indicator-height: 10px;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-color: #505050;
}
.pending-list-progress-bar {
  --mdc-linear-progress-track-height: 10px;
}
.mat-mdc-table {
  background: transparent !important;
}
.mat-mdc-header-row,
.mat-mdc-header-cell {
  background: rgb(51, 51, 51) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}
.mat-mdc-row,
.mat-mdc-cell {
  background: transparent !important;
  color: white;
}
.mat-mdc-row:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}
.mat-elevation-z8 {
  box-shadow: none !important;
}
.mat-mdc-cell {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.mat-mdc-row:last-child .mat-mdc-cell {
  border-bottom: none;
}
.mat-mdc-paginator {
  background: transparent;
  color: white !important;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.mat-mdc-paginator .mat-mdc-icon-button,
.mat-mdc-paginator .mat-mdc-select-value {
  color: white;
}
:host ::ng-deep .mat-mdc-paginator-icon {
  fill: white !important;
}
::ng-deep .html-content table {
  background: none !important;
  border-collapse: collapse !important;
  width: 100% !important;
}
::ng-deep .html-content tr,
::ng-deep .html-content td {
  background: none !important;
  padding: 8px !important;
  border: 1px solid #ddd !important;
}
::ng-deep .html-content tr:nth-child(even) {
  background: none !important;
}
::ng-deep .html-content tr[style*=background] {
  background: none !important;
}
::ng-deep .html-content td[bgcolor],
::ng-deep .html-content tr[bgcolor] {
  background: none !important;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  overflow-y: visible;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
ul > li {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  align-items: center;
}
ul > li > span {
  font-size: 15px;
}
ul > li > span.label-title {
  font-weight: 600;
  color: #999;
}
/*# sourceMappingURL=import-wizard-geospatial-mapping_adjust.component-IFUQZHJP.css.map */
